import { useCompanyApi } from '@/api/client/api-client';
import type { FeatureFlags } from '@/api/interfaces/feature-flags.types';
import { until } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const useFeatureFlagsStore = defineStore('featureFlags', () => {
    const companyFetch = useCompanyApi();
    const { data, isFinished } = companyFetch('/user/home/featureflags').json<FeatureFlags>();
    const flags = computed<FeatureFlags | undefined>(() => data.value ?? undefined);

    const ensureLoaded = async (): Promise<FeatureFlags | undefined> => {
        await until(isFinished).toBe(true);
        return flags.value;
    };

    return {
        flags,
        isFinished,
        ensureLoaded,
    };
});
